import React from 'react';
import { Heart } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { ProductGridSkeleton } from '../components/Skeleton';
import ErrorState from '../components/ErrorState';
import EmptyState from '../components/EmptyState';
import SectionHeading from '../components/SectionHeading';
import usePageMetadata from '../hooks/usePageMetadata';
import { useCart } from '../context/CartContext';
import { useFavourites } from '../context/FavouritesContext';

const FavouritesPage = () => {
  const { addItem, setQuantity, quantityFor } = useCart();
  const {
    isFavourite,
    loaded,
    loadError,
    favouriteProducts,
    refreshFavourites,
  } = useFavourites();
  const visibleProducts = favouriteProducts.filter((product) => isFavourite(product._id));

  usePageMetadata({
    title: 'Your Favourites | Fresh & Homely',
    description: 'Products you have saved at Fresh & Homely.',
    canonicalPath: '/favourites',
  });

  return (
    <>
      <Navbar />
      <section className="py-24 min-h-[60vh] bg-gradient-to-b from-white to-canvas">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            level="h1"
            align="left"
            title="Your Favourites"
            description="Products you've saved for later."
          />

          {!loaded && <ProductGridSkeleton count={8} />}
          {loaded && loadError && <ErrorState message={loadError.message} onRetry={refreshFavourites} />}
          {loaded && !loadError && visibleProducts.length === 0 && (
            <EmptyState
              icon={Heart}
              title="No favourites yet"
              description="Tap the heart icon on any product to save it here for quick access later."
              action={{ label: 'Explore Products', to: '/categories' }}
            />
          )}
          {loaded && !loadError && visibleProducts.length > 0 && (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
              {visibleProducts.map((product) => (
                <ProductCard
                  key={product._id}
                  product={product}
                  quantity={quantityFor(product._id)}
                  onAddToCart={addItem}
                  onSetQuantity={setQuantity}
                />
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default FavouritesPage;
